import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { OpenFormComponent } from 'src/app/component/open-form/open-form.component';
import { PagesService } from '../../services/pages.service';
import { jobFairFormField } from './forms/create-jobfair';
import { JobfairService } from './service/jobfair.service';
import { OpenForm2Component } from './open-form2/open-form2.component';

@Component({
	selector: 'app-jobfair',
	templateUrl: './jobfair.page.html',
	styleUrls: ['./jobfair.page.scss'],
})
export class JobfairPage implements OnInit {
	jobfairList$: Observable<any> = this.jobfairService.fetchJobFairListData();
	locationList: any;
	defaultLocationList: any;
	defaultTimeZoneList: any;
	timeZoneList: any;
	JobFunctionList: any;
	partnershipList: any;
	employees: any[] = [];
	defaultData: any = {};
	showHeaderFilter = true;
	currentPagePermission = 'jobfair';

	constructor(
		private router: Router,
		public popoverController: PopoverController,
		public modalController: ModalController,
		private jobfairService: JobfairService,
		public pagesService: PagesService,
	) {
		//

		this.pagesService.notValidPermissionByName(
			this.currentPagePermission,
			'/app',
		);
	}

	ngOnInit() {
		this.jobfairService.loadJobFairListInit();
		this.jobfairService.loadJobFairListData().subscribe();
		this.jobfairService.getLocationList().subscribe(data => {
			this.locationList = data;
			this.defaultLocationList = data?.data.find((e: any) => {
				return e.name === 'North America';
			});
		});
		this.jobfairService.getTimeZoneList().subscribe(data => {
			this.timeZoneList = data;
			this.defaultTimeZoneList = data?.data.find((e: any) => {
				return e.name === 'US/Pacific';
			});
		});
		this.jobfairService
			.getJobFunctionList()
			.subscribe(data => (this.JobFunctionList = data));
		this.jobfairService
			.getPartnershipList()
			.subscribe(data => (this.partnershipList = data));
	}
	isCanOpenBox = true;

	async addJobfair() {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenForm2Component,
				componentProps: {
					formTitle: 'Create Jobfair',
					form: jobFairFormField,
					values: {
						isActive: true,
						enableNotification: false,
						scheduleFinalised: false,
						visible: false,
						isEpp: false,
						cost: 'Free',
						virtual: true,
						timeZone: this.defaultTimeZoneList.id,
						location: this.defaultLocationList.id,
					},
					selectOptions: {
						location: this.locationList?.data,
						timeZone: this.timeZoneList?.data,
						jobFunction: this.JobFunctionList?.data,
						partnershipCompany: this.partnershipList?.data,
					},
					onSubmitForm: this.onCreate,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}

	onCreate(ref: any, editForm: any) {
		// return of([]);
		return ref.jobfairService.addJobfair({
			...editForm,
			title: editForm.title.trim(),
			name: editForm.name.trim(),
			canJoin: editForm.canJoin.trim(),
			description: editForm.description.trim(),
			jobFairDate: new Date(editForm.jobFairDate).getTime(),
			endDate: new Date(editForm.endDate).getTime(),
		});
	}

	async editInfo(jobfair: any) {
		this.defaultData = {
			id: jobfair.partnershipCompany.id,
			name: jobfair.partnershipCompany.name,
		};
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenForm2Component,
				componentProps: {
					form: jobFairFormField,
					formTitle: 'Edit jobfair',
					defaultData: this.defaultData,
					values: {
						...jobfair,
						location: jobfair.location.id || this.defaultLocationList.id,
						timeZone: jobfair.timeZone.id || this.defaultTimeZoneList.id,
						cost: jobfair.cost || 'Free',
						jobFunction: jobfair.jobFunction.id,
						partnershipCompany: jobfair.partnershipCompany.id,
						endDate: new Date(jobfair.endDate),
					},
					selectOptions: {
						location: this.locationList?.data,
						timeZone: this.timeZoneList?.data,
						jobFunction: this.JobFunctionList?.data,
						partnershipCompany: this.partnershipList?.data,
					},
					ref: this,
					onSubmitForm: this.update,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal
				.onDidDismiss()
				.then(() => this.jobfairService.loadJobFairListData().subscribe());

			this.isCanOpenBox = true;
		}
	}

	update(ref: any, editForm: any) {
		editForm.endDate = new Date(editForm.endDate).getTime();
		editForm.jobFairDate = new Date(editForm.jobFairDate).getTime();
		return ref.jobfairService.updateJobFairListData(editForm.id, {
			...editForm,
			title: editForm.title.trim(),
			name: editForm.name.trim(),
			canJoin: editForm.canJoin.trim(),
			description: editForm.description.trim(),
		});
	}

	viewInfo(id: any) {
		this.router.navigate([
			'app/jobfair/info/' + id + '/participatingcompanies',
		]);
	}
}
